import { render, staticRenderFns } from "./NameAnswer.vue?vue&type=template&id=02b6ab9b&"
import script from "./NameAnswer.vue?vue&type=script&lang=js&"
export * from "./NameAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports